import { tv, VariantProps } from "@/utils";

export const typography = tv({
  slots: {
    base: ["text-pretty"],
  },
  variants: {
    fontSize: {
      ["heading-xl"]: {
        base: ["text-5xl lg:text-6xl"],
      },
      ["heading-lg"]: {
        base: ["text-2xl sm:text-3xl md:text-5xl"],
      },
      ["heading-md"]: {
        base: ["text-2xl md:text-3xl lg:text-4xl"],
      },
      ["heading-sm"]: {
        base: ["text-xl md:text-2xl lg:text-3xl"],
      },
      ["heading-xs"]: {
        base: ["text-lg md:text-xl lg:text-2xl"],
      },
      ["heading-xxs"]: {
        base: ["text-base md:text-lg lg:text-xl"],
      },
      ["body-xl"]: {
        base: ["text-xl"],
      },
      ["body-lg"]: {
        base: ["text-lg"],
      },
      ["body-md"]: {
        base: ["text-base"],
      },
      ["body-sm"]: {
        base: ["text-sm"],
      },
      ["body-xs"]: {
        base: ["text-xs"],
      },
    },
    fontFamily: {
      roboto: {
        base: ["font-roboto"],
      },
      chillen: {
        base: ["font-chillen tracking-widest"],
      },
    },
    fontWeight: {
      light: {
        base: ["font-light"],
      },
      normal: {
        base: ["font-normal"],
      },
      medium: {
        base: ["font-medium"],
      },
      semibold: {
        base: ["font-semibold"],
      },
      bold: {
        base: ["font-bold"],
      },
    },
    spacing: {
      tighter: {
        base: ["!tracking-tighter"],
      },
      tight: {
        base: ["!tracking-tight"],
      },
      normal: {
        base: ["!tracking-normal"],
      },
      wide: {
        base: ["!tracking-wide"],
      },
      wider: {
        base: ["!tracking-wider"],
      },
      widest: {
        base: ["!tracking-widest"],
      },
    },
    lineHeight: {
      none: ["!leading-none"],
      tight: ["!leading-tight"],
      snug: ["!leading-snug"],
      normal: ["!leading-normal"],
      relaxed: ["!leading-relaxed"],
      loose: ["!leading-loose"],
    },
    uppercase: {
      false: {},
      true: {
        base: ["uppercase"],
      },
    },
    italic: {
      true: {
        base: ["italic"],
      },
    },
  },
  defaultVariants: {
    fontSize: "body-md",
    fontFamily: "roboto",
    uppercase: false,
    italic: false,
  },
});

export type TypographyVariantProps = VariantProps<typeof typography>;

export type TypographyReturnVariantProps = ReturnType<typeof typography>;
